
import './Assets/Scss/style.scss';


// components

import Navbar from './Components/Navbar';
import Footer from './Components/Footer';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// login auth

import Login from './Auth/Login';
import Register from './Auth/Register';
import ForgetPassword from './Auth/Forget';
import NewPassword from './Auth/NewPassword';


// pages

import Banner from './Pages/Banner';
import About from './Pages/About';
import AboutMain from './About/About';
import FeaProduct from './Product/FeaturedProduct';
import AllProduct from './Product/AllProduct';
import AllCard from './Product/AddCard';
import ProductView from './Product/ViewProduct';
import ContactUs from './Contact/Contact';
import Result from './Pages/Result';
import ProductSingle from './Pages/Product_single';
import Testmonial from "./Pages/Testmonial"; 
import CheckoutDetails from './PaymentDetials/Checkout';


// Admin


function App() {

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* ================= USER ROUTES ================= */}
          <Route
            path="/*"
            element={
              <>
                <header>
                  <Navbar />
                </header>
                <main>
                  <Routes>
                    <Route index element={<Banner />} />
                    <Route element={<About />} />
                    <Route path="about" element={<AboutMain />} />
                    <Route element={<FeaProduct />} />
                    <Route path="product" element={<AllProduct />} />
                    <Route path="contact" element={<ContactUs />} />
                    <Route path="result" element={<Result />} />
                    <Route path="product_clac" element={<ProductSingle />} />
                    <Route path="productview" element={<ProductView />} />

                    <Route path="testmonial" element={<Testmonial />} />
                    <Route path="login" element={<Login />} />
                    <Route path="register" element={<Register />} />
                    <Route path="forget" element={<ForgetPassword />} />
                    <Route path="newpassword" element={<NewPassword />} />
                    <Route path="card" element={<AllCard />} />
                  </Routes>
                </main>
                <Footer />
              </>
            }
          />
           <Route path="/checkout-details" element={<CheckoutDetails />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
 